import * as _ from 'lodash';
import { IOpsSchedule, IContact } from "@nkr/models/index";
import { DisplayType, OpsScheduleStatus } from '@nkr/enums/index';
import { TableWrapper } from "./styles";
import PreviewRow from "./preview-row";
import * as moment from 'moment';

interface IProps {
    schedule: IOpsSchedule[],
    display: DisplayType,
    staffList: IContact[]
}

const Preview = (props: IProps) => {
    const getHeaders = (list: IOpsSchedule[]) => {
        let headers: { start: string, end: string }[] = [];

        for (let d = 0; d < 5; d++) {
            let startTimes = [];
            let endTimes = [];

            for (let r = 0; r < list.length; r++) {
                let row = list[r];
                let sortedDays = _.sortBy(row.days, x => x.displayOrder);

                let startTime = moment('2001-01-01 ' + sortedDays[d].startTime, 'YYYY-MM-DD HH:mm', true);
                let endTime = moment('2001-01-01 ' + sortedDays[d].endTime, 'YYYY-MM-DD HH:mm', true);

                if (startTime.isValid()) {
                    startTimes.push(startTime);
                }

                if (endTime.isValid()) {
                    endTimes.push(endTime);
                }
            }

            let start = moment.min(startTimes).format('HH:mm');
            let end = moment.max(endTimes).format('HH:mm');

            headers.push({ start, end });
        }

        return headers;
    };

    const list = _.sortBy(props.schedule.filter(x => x.status == OpsScheduleStatus.Included), x => x.displayOrder);
    const style = props.display != DisplayType.All ? { display: 'flex', alignItems: 'center', height: '70vh' } : null;
    const fontSize = props.display == DisplayType.All ? null : '16px';
    const headers = getHeaders(list);

    return (
        <div style={style}>
            <TableWrapper fontSize={fontSize} style={{ marginBottom: 0 }}>
                <thead>
                    <tr>
                        <th style={{ border: '0 none' }}></th>
                        <th style={{ backgroundColor: 'lightblue', border: '1px solid #ddd' }}>Office Coverage</th>
                        <th colSpan={2} style={{ border: '1px solid #ddd' }}>MON</th>
                        <th colSpan={2} style={{ backgroundColor: 'lightblue', border: '1px solid #ddd' }}>TUE</th>
                        <th colSpan={2} style={{ border: '1px solid #ddd' }}>WED</th>
                        <th colSpan={2} style={{ backgroundColor: 'lightblue', border: '1px solid #ddd' }}>THU</th>
                        <th colSpan={2} style={{ border: '1px solid #ddd' }}>FRI</th>
                    </tr>
                    <tr style={{ backgroundColor: '#133666', color: 'white' }}>
                        <th style={{ backgroundColor: 'white', border: '0 none' }}></th>
                        <th style={{ width: 150 }}>Employee</th>
                        {headers.map(header =>
                            <>
                                <th>{header.start}</th>
                                <th>{header.end}</th>
                            </>
                        )}
                        {/* <th>8:00</th>
                        <th>19:00</th>
                        <th>8:00</th>
                        <th>19:00</th>
                        <th>8:00</th>
                        <th>19:00</th>
                        <th>8:00</th>
                        <th>19:00</th>
                        <th>8:00</th>
                        <th>19:00</th> */}
                    </tr>
                </thead>
                <tbody>
                    {list.map((item, index) =>
                        <PreviewRow
                            key={'preview-' + index}
                            index={index}
                            count={list.length}
                            data={item}
                            staffList={props.staffList}
                        />
                    )}

                    {list.filter(x => x.employeeId > 0).length == 0 && (
                        <tr>
                            <td style={{ color: '#333', backgroundColor: 'white' }}>Office Hours</td>
                            <td colSpan={11}></td>
                        </tr>
                    )}
                </tbody>
            </TableWrapper>
        </div>
    );
}

export default Preview;